const cdn = {
  region: 'us-west-1',
  distributionId: process.env.CDN_DISTRIBUTION_ID!,
  invalidateOnPublish: process.env.CDN_INVALIDATE_ON_PUBLISH === 'true',
  url: process.env.NEXT_PUBLIC_CDN_URL!,
};
export default cdn;
